import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  superadminAPI,
  setSuperAdminSession,
  getSuperAdminToken,
  isSuperAdminTokenValid,
} from "../../api/superadminClient";
import "./SuperAdminPages.css";

export default function SuperAdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = getSuperAdminToken();
    if (isSuperAdminTokenValid(token)) {
      navigate("/superadmin", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const resp = await superadminAPI.login(email, password);
      setSuperAdminSession(resp.data?.accessToken, resp.data?.superAdmin);
      navigate("/superadmin", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="superadmin-auth-shell">
      <div className="superadmin-auth-card">
        <h1>Superadmin Login</h1>
        <p>Dedicated access for platform administration only.</p>
        <form className="superadmin-auth-form" onSubmit={handleSubmit}>
          {error ? <div className="superadmin-error">{error}</div> : null}
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          <button type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p
          style={{
            margin: "16px 0 0",
            fontSize: 12,
            color: "#94a3b8",
            textAlign: "center",
          }}
        >
          © 2026 DecisionFlow. All rights reserved.
        </p>
      </div>
    </div>
  );
}
